import { isUuid } from '@notifi/uuid/validate';
import { createFileRoute } from '@tanstack/react-router';
import { StockPage } from '@/features/inventory/StockPage';
export const Route = createFileRoute('/_dashboard/dashboard/inventory/stock')({
  validateSearch: (
    search: Record<string, unknown>,
  ): { belowMin?: boolean; locationId?: string } => ({
    belowMin: search.belowMin === true || search.belowMin === 'true' ? true : undefined,
    locationId: isUuid(search.locationId) ? (search.locationId as string) : undefined,
  }),
  component: Page,
});
function Page() {
  const { belowMin, locationId } = Route.useSearch();
  return (
    <StockPage
      key={`${belowMin ? 'below' : 'all'}:${locationId ?? ''}`}
      belowMin={belowMin}
      locationId={locationId}
    />
  );
}
